import { useState } from 'react';
import { useIntl } from 'react-intl';
import { SELECT_MEDIA_DIALOG_MODE } from '../../../lib/constants';

const FRAME_LIMIT = 100; // フレーム数の上限

const useMediaSelection = ({
  timelines,
  frames,
  setSelectedUpdateImage,
  selectMediaDialogMode,
  noImageId,
  dispatch,
}) => {
  const intl = useIntl();
  // 追加する写真
  const [selectedAddImages, setSelectedAddImages] = useState([]);

  const handleAddImage = id => {
    const imageObject = timelines.find(image => image.id === id);
    if (!imageObject) {
      const alreadyNoImageSelected = selectedAddImages.some(
        image => image === noImageId,
      );
      if (alreadyNoImageSelected) {
        setSelectedAddImages(
          selectedAddImages.filter(image => image !== noImageId),
        );
      } else {
        setSelectedAddImages([...selectedAddImages, noImageId]);
      }
      return;
    }
    if (selectedAddImages.some(image => image.id === id)) {
      setSelectedAddImages(selectedAddImages.filter(image => image.id !== id));
    } else {
      setSelectedAddImages([...selectedAddImages, imageObject]);
    }
  };

  const handleUpdateImage = id => {
    if (id === noImageId) {
      setSelectedUpdateImage(noImageId);
      return;
    }
    setSelectedUpdateImage(timelines.find(image => image.id === id));
  };

  // 画像を選択した時の処理を行う
  // 画像の追加または更新を行うが、追加の場合はフレーム数の上限に達していないか確認する
  const handleImageClick = id => {
    // 更新モードの場合は選択した画像で更新を行う
    if (selectMediaDialogMode === SELECT_MEDIA_DIALOG_MODE.UPDATE) {
      handleUpdateImage(id);
      return;
    }

    const includeImageInSelectedAddImages = selectedAddImages.some(
      image => image?.id === id,
    );
    const isWithinFrameLimit =
      frames.filter(frame => frame.id != null).length +
        selectedAddImages.length <
      FRAME_LIMIT;
    const canSelectImage =
      isWithinFrameLimit ||
      (includeImageInSelectedAddImages &&
        frames.filter(frame => frame.id != null).length +
          selectedAddImages.length <=
          FRAME_LIMIT) ||
      (id === noImageId && selectedAddImages.includes(noImageId));

    // 画像を追加できない場合はフレーム数の上限に達したことを通知する
    if (!canSelectImage) {
      dispatch({
        type: 'OPEN_USER_PROMPT',
        promptMessage: intl.formatMessage({
          id: 'userPrompt.message.reportEdit.frameLimit',
        }),
        buttonArray: [
          {
            name: intl.formatMessage({ id: 'userPrompt.button.close' }),
            type: 0,
          },
        ],
      });
      return;
    }

    // 追加モードの場合は選択した画像でフレーム追加を行う
    handleAddImage(id);
  };

  return {
    selectedAddImages,
    handleImageClick,
  };
};

export default useMediaSelection;
